<template>
  <div class="detail-container">
    <DetailHead />
    <DetailCont />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import DetailHead from './components/DetailHead'
import DetailCont from './components/DetailCont'

export default {
  name: 'Detail',
  components: {
    DetailHead,
    DetailCont,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState([
    ]),
    ...mapGetters([
      'vx_get_token'
    ]),
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations([
      'vx_setData'
    ]),
    ...mapActions([
      'vx_act_findOne'
    ]),
    init() {
      if (this.vx_get_token) this.vx_act_findOne()
    }
  }
}
</script>

<style lang="less" scoped>
.detail-container {
  min-width: @gb_minWidth;
  min-height: 100%;
  background: #182132;
}
</style>
